var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9583 11.9583H14.5417V1.54167C14.5417 1.2654 14.4319 1.00045 14.2366 0.805097C14.0412 0.609747 13.7763 0.5 13.5 0.5V0.5C13.2237 0.5 12.9588 0.609747 12.7634 0.805097C12.5681 1.00045 12.4583 1.2654 12.4583 1.54167V11.9583H2.04167C1.7654 11.9583 1.50045 12.0681 1.3051 12.2634C1.10975 12.4588 1 12.7237 1 13H1C1 13.2763 1.10975 13.5412 1.3051 13.7366C1.50045 13.9319 1.7654 14.0417 2.04167 14.0417H12.4583V24.4583C12.4583 24.7346 12.5681 24.9996 12.7634 25.1949C12.9588 25.3903 13.2237 25.5 13.5 25.5C13.7763 25.5 14.0412 25.3903 14.2366 25.1949C14.4319 24.9996 14.5417 24.7346 14.5417 24.4583V14.0417H24.9583C25.2346 14.0417 25.4996 13.9319 25.6949 13.7366C25.8903 13.5412 26 13.2763 26 13C26 12.7237 25.8903 12.4588 25.6949 12.2634C25.4996 12.0681 25.2346 11.9583 24.9583 11.9583Z",
    fill: "#735BF2",
    stroke: "#735BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusPrimary);
export default __webpack_public_path__ + "static/media/iconPlusPrimary.e88e63b29445271a4326afd945c3a353.svg";
export { ForwardRef as ReactComponent };